import { render } from "./suggestList.vue?vue&type=template&id=1ad7d980&ts=true"
import script from "./suggestList.vue?vue&type=script&lang=ts&config=true"
export * from "./suggestList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__